import React from "react";
import { ReactiveBaseProps } from "@usereactify/search-internals/lib/components/basic/ReactiveBase";

import { getCookie, useReactifySearchContext } from "../../hooks";

import pkg from "../../../package.json";
import { getPropsBase } from "../../utility/props";

export const replaceDocCountWithParent = (response: any) => {
  Object.entries(response)
    .filter(([key]) => key !== "doc_count")
    .forEach(([key, value]: [string, any]) => {
      value.buckets?.forEach((bucket: any) => {
        if (bucket.parent_docs) {
          bucket.doc_count = bucket.parent_docs.doc_count;
          delete bucket.parent_docs;
        }
      });
    });

  return response;
};

export const useReactiveBaseProps = (): ReactiveBaseProps => {
  const { options, config } = useReactifySearchContext();
  
  const reactiveBasePropsShared = getPropsBase({
    provider: options,
    config: config,
    query: options.query,
  })

  const reactiveBaseProps = React.useMemo<ReactiveBaseProps>(
    () => ({
      ...reactiveBasePropsShared,
      initialState: options.preload?.state,
      headers: {
        ...reactiveBasePropsShared.headers,
        "x-reactify-ga": getCookie("_rs_ga"),
      },
    }),
    [options.index, config.endpoint, options.credentials, options.theme, options.preload?.state]
  );

  return reactiveBaseProps;
};
